import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  Row,
  Button,
  Form,
  Label,
  Input,
  FormGroup,
  Spinner,
} from "reactstrap";
import { updateRestaurantProfile } from "store/actions/settingAction";
import SocialProfileTable from "./SocialProfileTable";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
import { toast } from "react-toastify";

const libraries = ["places"];

const AccountSettingTable = ({
  data,
  addToggle,
  editToggle,
  deleteToggle,
  setEditData,
  setIndex,
}) => {
  const history = useHistory();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCqDBbD8FWoozg43IbPISgnDpwNhvNmqh0",
    libraries,
  });
  const dispatch = useDispatch();
  const { user, uid } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.setting);
  const [locationData, setLocationData] = useState(null);
  const [isLocationSelected, setIsLocationSelected] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    location: "",
    description: "",
    subScriptionStatus: "",
    coordinates: {
      latitude: "",
      longitude: "",
    },
  });

  const [emailError, setEmailError] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEmailError("");
    if (name === "location") {
      setIsLocationSelected(false);
    }
    setFormData({ ...formData, [name]: value });
    if (name === "email" && !validateEmail(value)) {
      setEmailError("Please enter a valid email address (example@gmail.com)");
    } else {
      setEmailError("");
    }
  };

  const handlePlaceSelect = (place) => {

    const address = place.formatted_address;
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    setFormData({
      ...formData,
      location: address,
      coordinates: {
        latitude: lat,
        longitude: lng,
      },
    });
    setIsLocationSelected(true);
  };

  const handleProfileUpdate = (evt, elements, stripe) => {
    evt.preventDefault();
    const { email } = formData;
    if (!validateEmail(email)) {
      return;
    } else if (!isLocationSelected) {
      toast.error("Please select a valid location from the suggestions.");
      return;
    } else {
      dispatch(updateRestaurantProfile(uid, formData));
    }
  };

  useEffect(() => {
    setFormData({
      name: user?.name,
      email: user?.email,
      subScriptionStatus: user?.subScriptionStatus
        ? user?.subScriptionStatus
        : "",
      description: user?.description || "",
      location: user?.location,
    });
  }, [user]);
  const validateEmail = (email) => {
    return (
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email) &&
      !email.includes(" ")
    );
  };
  return (
    <>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="d-lg-flex  d-sm-block justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  size="sm"
                  color="primary"
                  onClick={() => {
                    history.push("/admin/settings");
                  }}
                >
                  <i className="fas fa-arrow-left "></i>
                </Button>

                <h3 className=" pt-2 ">Account Settings</h3>
              </div>
            </CardHeader>
            <div className="mx-3 mx-md-5 my-2">
              <h3 className=" pt-2 ">Restaurant Profile</h3>

              <Form onSubmit={(evt) => handleProfileUpdate(evt)}>
                <FormGroup>
                  <Label>Name</Label>
                  <Input
                    type="text"
                    name="name"
                    required
                    placeholder="Enter Your Restaurant Name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Email</Label>
                  <Input
                    type="text"
                    name="email"
                    placeholder="Update Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    disabled
                  />
                  {emailError && (
                    <span className="text-danger" style={{ fontSize: "11px" }}>
                      {emailError}
                    </span>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label>Location</Label>
                  {isLoaded && (
                    <Autocomplete
                      onLoad={(autocomplete) => {
                        setLocationData(autocomplete);
                      }}
                      onPlaceChanged={() => {
                        const place = locationData.getPlace();
                        if (place && place.geometry) {
                          handlePlaceSelect(place);
                        }
                      }}
                    >
                      <Input
                        type="text"
                        name="location"
                        required
                        placeholder="Enter Your Location"
                        value={formData.location}
                        onChange={handleInputChange}
                      />
                    </Autocomplete>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label>Detail Description</Label>
                  <Input
                    type="textarea"
                    name="description"
                    required
                    placeholder="Enter Restaurant Detail Description..."
                    value={formData.description}
                    onChange={handleInputChange}
                  />
                </FormGroup>

                <div className="d-flex justify-content-end">
                  <Button
                    color="primary"
                    className="custom-class"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? <Spinner size="sm" /> : "Update"}
                  </Button>
                </div>
              </Form>
              <SocialProfileTable
                data={data}
                addToggle={addToggle}
                editToggle={editToggle}
                deleteToggle={deleteToggle}
                setEditData={setEditData}
                setIndex={setIndex}
              />
            </div>
          </Card>
        </div>
      </Row>
    </>
  );
};

export default AccountSettingTable;
